export default function isTutorialHidden(user) {
  return !!(user && user.preferences && user.preferences.tutorial
    && user.preferences.tutorial.hideOnStartup);
}
